import React, { useRef, useState } from "react";
import api, { fileUrl } from "../../api";
import { toast } from "sonner";
import { Upload, X, Image as ImageIcon, Film, Loader2 } from "lucide-react";

// Single-file uploader. kind: 'image' | 'video'. Calls onChange(url).
export default function FileUpload({ label, kind = "image", value, onChange, compact }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const [pct, setPct] = useState(0);

  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true); setPct(0);
    try {
      let res;
      if (kind === "video") res = await api.uploadVideo(f, setPct);
      else res = await api.uploadImage(f);
      onChange(res.url);
      toast.success("Файл загружен");
    } catch (err) {
      toast.error("Ошибка загрузки");
    } finally {
      setBusy(false); setPct(0);
      if (ref.current) ref.current.value = "";
    }
  };

  const accept = kind === "video" ? "video/*" : "image/*";

  return (
    <div>
      {label && <span className="text-xs text-white/50 mb-1.5 block">{label}</span>}
      <input ref={ref} type="file" accept={accept} onChange={handle} className="hidden" />

      {value && kind === "image" && (
        <div className="relative inline-block mb-2">
          <img src={fileUrl(value)} alt="" className={`rounded-xl border border-white/10 object-cover ${compact ? "h-16 w-16" : "h-24 w-40"}`} />
          <button type="button" onClick={() => onChange("")} className="absolute -top-2 -right-2 h-6 w-6 rounded-full bg-black border border-white/20 flex items-center justify-center text-white/70 hover:text-red-400"><X size={13} /></button>
        </div>
      )}
      {value && kind === "video" && (
        <div className="mb-2 flex items-center gap-2 rounded-xl border border-[#d6ff71]/40 bg-[#d6ff71]/10 px-3 py-2 text-sm text-[#d6ff71]">
          <Film size={16} /> Видео загружено
          <button type="button" onClick={() => onChange("")} className="ml-auto text-white/50 hover:text-red-400"><X size={14} /></button>
        </div>
      )}

      <button
        type="button"
        onClick={() => ref.current?.click()}
        disabled={busy}
        className="inline-flex items-center gap-2 rounded-xl border border-white/15 bg-black/40 px-4 py-2 text-sm hover:border-[#ff3798] transition-colors disabled:opacity-60"
      >
        {busy ? <Loader2 size={15} className="animate-spin" /> : kind === "video" ? <Film size={15} /> : <ImageIcon size={15} />}
        {busy ? (kind === "video" ? `Загрузка ${pct}%` : "Загрузка...") : value ? "Заменить файл" : (kind === "video" ? "Загрузить видео" : "Загрузить фото")}
      </button>

      {busy && kind === "video" && (
        <div className="mt-2 h-2 rounded-full bg-white/10 overflow-hidden">
          <div className="h-full rounded-full bg-gradient-to-r from-[#ff3798] to-[#d6ff71] transition-all" style={{ width: `${pct}%` }} />
        </div>
      )}
    </div>
  );
}
